module.exports = __webpack_public_path__ + "media/components/country-flag/static/um-13700d16d565470751f43b7d2983bc20.svg";